import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface LoginResponse extends BackendResponse {
  token: CVPortalCandidateToken;
}

export interface LoginParameters extends NextApiParams {
  idConcern: number;
  idCandidate: number | null;
  email: string;
  password: string;
}

export const login = withNextApi<LoginResponse, LoginParameters>(
  "/cvp/CvpLogin"
);

export interface CVPortalCandidateToken {
  id: number | null;
  idConcern: number;
  idCandidate: number;
  token: string;
  hash: string;
  expires: string;
  added: string;
}
